import { SummarizeConversationMessage } from '@@types/models/CreateReport';

import { SingleMessage } from '@domains/new-conversation/atoms/SingleMessage/SingleMessage';
import { ResponseWrapper } from '@domains/new-conversation/molecules/SummaryResponseMessage/SummaryResponseMessage.styled';

interface SummaryResponseMessageProps {
    message: SummarizeConversationMessage;
    showAvatar?: boolean;
}

export const SummaryResponseMessage = ({
    message,
    showAvatar,
}: SummaryResponseMessageProps) => {
    return (
        <ResponseWrapper firstResponse={showAvatar}>
            <SingleMessage showAvatar={showAvatar}>
                {message.textTranslated}
            </SingleMessage>
        </ResponseWrapper>
    );
};
